// Returns the next question ID based on the response and whether the question is branching
export const getNextQuestionId = (questionId, response, questionnaireNodeList, responseBranchOptions, responses) => {
	questionId = parseInt(questionId);

	let currentNodeIndex = questionnaireNodeList.findIndex(node => node.questionId === questionId);
	let currentNode = questionnaireNodeList[currentNodeIndex];

	let nextNode = null;
	let nextNodeIndex = currentNodeIndex + 1;
	if (nextNodeIndex < questionnaireNodeList.length) {
		let childrenCount = (currentNode.children !== null ? currentNode.children.length : 0);

		if(childrenCount > 0) {
			// This question is a branching question since it has child nodes, so determine whether the response is the branching response
			if (response) {
				let questionBranchOption = responseBranchOptions.find(responseBranchOption => responseBranchOption.questionId === questionId);

				if (questionBranchOption.branchOption === response.toString()) {
					// The response is the branching response, so go to the next immediate node
					nextNode = questionnaireNodeList[nextNodeIndex];
				}
				else {
					// The response is not the branching response, so skip over the child nodes associated with a branching response
					nextNode = questionnaireNodeList[getNextNodeForNonBranchResponse(currentNode, nextNodeIndex, questionnaireNodeList, responses)];
				}
			}
			else {
				// No response was provided,  so skip over the child nodes associated with a branching response
				nextNode = questionnaireNodeList[getNextNodeForNonBranchResponse(currentNode, nextNodeIndex, questionnaireNodeList, responses)];
			}
		}
		else {
			// This question is not branching, so go to the next immediate node
			nextNode = questionnaireNodeList[nextNodeIndex];
		}
	}

	if(nextNode) {
		return nextNode.questionId;
	}

	return null; // If no nodes remain (i.e. this is the final question), return null
}

const getNextNodeForNonBranchResponse = (node, nodeIndex, questionnaireNodeList, responses) => {
	let children = node.children;

	children.forEach(child => {
		nodeIndex++;

		// Clear any existing response to branch questions that are not applicable
		let response = responses.find(response => response.questionId === child.data.deQuestionId.toString());
		response.response = undefined;

		// If this child has children (branching questions), recursively call this function again to perform the same operations
		if(child.children) {
			nodeIndex = getNextNodeForNonBranchResponse(child, nodeIndex, questionnaireNodeList, responses);
		}
	});

 	return nodeIndex;
}

// Encodes a filename to AWS S3's format
export const encodeS3URI = (filename) => {
    const encodings = {
        '\+': "%2B",
        '\!': "%21",
        '\"': "%22",
        '\#': "%23",
        '\$': "%24",
        '\&': "%26",
        '\'': "%27",
        '\(': "%28",
        '\)': "%29",
        '\*': "%2A",
        '\,': "%2C",
	 // '\:': "%3A", - Removed since this breaks the protocol substring (i.e. "https:") when a full URL is received as a parameter
        '\;': "%3B",
        '\=': "%3D",
        '\?': "%3F",
        '\@': "%40",
    };

	return encodeURI(filename).replace(/([+!"#$&'()*+,;=?@])/img, match => encodings[match]);
}